import axios from 'axios';

export function fetchSurveyTemplate(params: {surveyTemplateId: string}) {
    return axios.get(`${process.env.REACT_APP_API_HOST}/survey-templates/${params.surveyTemplateId}`);
}
